import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import * as colors from '../common/colorConstants';
import * as breakpoints from '../common/mediaQueries';
import { textStyles, smallTextStyles } from '../LoginPage/LoginPage.styles';

export const ResendLink = styled(Link)`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${colors.purple1};
`;

export const ResendLinkContainer = styled.div`
  margin 15px 0 4px;

`;

export const SubmitWrapper = styled.div`
  margin-top: 32px;

  &.error {
    margin-top: 16px;
  }
`;

export const Submit = styled.button`
  border: none;
  border-radius: 3px;
  width: 100%;
  height: 30px;
  background: ${colors.blue2};
  color: ${colors.white};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 40px;
  }

  &:disabled {
    background: ${colors.darkGray1};
    cursor: default;
  }
`;

export const PrivacyAndTermsWrapper = styled.div`
  padding: 5px;
`;

export const SmallLinkExternal = styled.a`
  ${smallTextStyles};
  color: ${colors.electricBlue};
  text-decoration: none;
`;

export const SmallTextBlue = styled.span`
  ${smallTextStyles};
  color: ${colors.electricBlue};
  text-decoration: none;
`;

export const SmallText = styled.p`
  margin: 0;
  padding: 0;
  ${smallTextStyles};
`;

export const ContentWrapper = styled.div`
  position: relative;
  padding: 0 56px;
  text-align: left;
  max-width: 412px;
  margin 0 auto;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    max-width: 369px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    padding: 0 24px;
  }
`;

export const TextInput = styled.input`
  padding: 11px 0;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  width: 40px;
  ${textStyles}
  color: ${colors.lightBlack};
  background-color: ${colors.white};
  outline: none;
  margin-left: 12px;
  text-align: center;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin-left: 3.4px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    margin-left: 16px;
  }

  &:focus {
    border: 1px solid ${colors.blue1};
    background-color: ${colors.activeInputGray};
  }

  &:first-child{
    margin-left: 0;
  }

  &.error {
    border: 1px solid ${colors.red3}};
  };
  
  &.error {
    background-color: ${colors.intentValidation.red2};
  };

  &::placeholder {
    ${textStyles};
  };
`;

export const ExpirationLinkWrapper = styled.div`
  margin-top: 20px;
`;

export const ExpirationLink = styled.a`
  border: none;
  border-radius: 3px;
  width: 100%;
  height: 30px;
  background: ${colors.blue2};
  color: ${colors.white};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  line-height: 16px;
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 40px;
  }
`;
